import type { ShareAuthCheckData } from '../types';

export const DuplicateCreateApi = Symbol('DuplicateCreateApi');

export interface DuplicateCreateApi {
    createShareTask(inputData: ShareAuthCheckData): Promise<string>
}
